import React, { useState } from 'react'
import './FAQ.css'

const FAQ = ({ colourScheme, faqs }) => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    }

    // Default FAQs if none provided
    const defaultFAQs = [
        {
            question: "What should I wear?",
            answer: "The dress code for our wedding is semi-formal. We'd love to see you dressed up, but comfort is key!"
        },
        {
            question: "Can I bring a plus one?",
            answer: "Due to venue capacity, we are only able to accommodate those guests formally invited on your invitation."
        },
        {
            question: "Will there be parking available?",
            answer: "Yes, there is ample parking available at the venue. Please follow the signs upon arrival."
        },
        {
            question: "What time should I arrive?",
            answer: "Please arrive 15-20 minutes before the ceremony start time to allow for seating."
        }
    ];

    const displayFAQs = faqs && faqs.length > 0 ? faqs : defaultFAQs;

    return (
        <div className={`faq-container ${colourScheme}-faq`}>
            {/* FAQ image decoration - right side */}
            <img src={require(`../../Assets/custom-site/${colourScheme}/faq.png`)} alt="Decoration" className="faq-decoration-img" />

            <h2 className="faq-title">Q&As</h2>

            <div className="faq-list">
                {displayFAQs.map((faq, index) => (
                    <div key={index} className="faq-item">
                        <div className="faq-question-row" onClick={() => toggleFAQ(index)}>
                            <div className={`faq-icon ${openIndex === index ? 'open' : ''}`}>
                                <span className="faq-icon-line horizontal"></span>
                                <span className="faq-icon-line vertical"></span>
                            </div>
                            <h3 className="faq-question">{faq.question}</h3>
                        </div>

                        <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                            <p>{faq.answer}</p>
                        </div>

                        {index < displayFAQs.length - 1 && <div className="faq-divider"></div>}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default FAQ